import { render } from "./KamranEntries.vue?vue&type=template&id=540c3a03&scoped=true"
import script from "./KamranEntries.vue?vue&type=script&lang=js"
export * from "./KamranEntries.vue?vue&type=script&lang=js"

import "./KamranEntries.vue?vue&type=style&index=0&id=540c3a03&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-540c3a03"]])

export default __exports__